// extracted by mini-css-extract-plugin
module.exports = {"btnLearnersbucket":"home_btnLearnersbucket__2v-Iy","homePage":"home_homePage__3-Pqt"};